// startup
// Load entry module and return exports
__webpack_require__("./app/widget/dining/src/index.js");
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = __webpack_require__("./js/3p/stacktrace-with-polyfills.min.js");
